const strictEqual = (a, b) => a === b

export default strictEqual